import type { StringKeyOf } from 'type-fest';

// Note about conventions for this map:
//  - The key describes what type of nudge it is.
//  - Keys/values are created manually right now, but could be automated in the future.
export const NUDGE_FEATURE_ID_MAP = {
  createMusic: 'createMusic-bebda4d7-ce7a-4027-93d3-9be5378f86d2',
  hostingPlayerColor: 'hostingPlayerColor-cd2f9fd0-dea1-4010-aa4f-4d460214218c',
  hostingChannels: 'hostingChannels-361eb2ce-3682-4a61-99fa-d571d0ea1dca',
  recordEditExperiment: 'recordEditExperiment-24550e30-5242-49e6-8530-0b19b3d7a024',
  videoBumperNudge: 'videoBumperNudge-6fdb3a15-2826-451a-a942-8a94f7dcbda7',
} as const;

export type SupportedNudgeFeatureIds = StringKeyOf<typeof NUDGE_FEATURE_ID_MAP>;
